<div class="scroll-indicator">
  <app-text-shape class="scroll-indicator__arrow" [autoplay]="true" shape="arrow-20"></app-text-shape>
  <span>{{ text }}</span>
</div>
